export const DEFAULT_CITY = 'Des Moines';
export const DEFAULT_STATE = 'IA';
export const DEFAULT_MAP_CENTER = [41.5868, -93.6250]; // Des Moines, IA coordinates
